import { buildManagementRoutes } from '../routes';

export const RESULT_TOPICS_EVENT = 'psi-result-topics-change';

let cachedTopicRoutes = null;

const sanitizeLabel = value => {
  const label = String(value || '').trim();
  return label || 'Mavzu';
};

export const mapResultTopicsToRoutes = topics =>
  (Array.isArray(topics) ? topics : [])
    .filter(topic => String(topic?.key || '').trim() !== '')
    .filter(topic => Number(topic?.question_count || 0) > 0)
    .filter(topic => !topic?.is_archived)
    .map(topic => ({
      key: String(topic.key).trim(),
      name: sanitizeLabel(topic.title || topic.name || topic.key),
      to: '/natijalar',
      search: `?kalit=${encodeURIComponent(String(topic.key).trim())}`
    }));

export const getCachedResultTopicRoutes = () => (Array.isArray(cachedTopicRoutes) ? cachedTopicRoutes : []);

export const emitResultTopicsUpdate = topics => {
  const nextRoutes = mapResultTopicsToRoutes(topics);
  cachedTopicRoutes = nextRoutes;

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(RESULT_TOPICS_EVENT, {
        detail: nextRoutes
      })
    );
  }

  return nextRoutes;
};

export const buildNavigationRoutes = topicRoutes => buildManagementRoutes(topicRoutes || getCachedResultTopicRoutes());
